'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, useLayoutEffect, useRef } from 'react';
import Image from '@/components/Image';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import { gsap } from '@/lib/gsap';
import Card from './Card';
import css from './style.module.scss';
import { EssenceDto } from './types';
interface Props {
  data: EssenceDto;
}
const Essence: FC<Props> = t0 => {
  const $ = _c(13);
  const {
    data
  } = t0;
  const wrapperRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const wrapper = wrapperRef.current;
      const cards = wrapper?.querySelectorAll(`.${css.card}`);
      if (!wrapper || !cards?.length) {
        return;
      }
      const ctx = gsap.context(() => {
        const matchMedia = gsap.matchMedia();
        matchMedia.add({
          isDesktop: "(min-width: 992px)",
          isMobile: "(max-width: 991px)"
        }, context => {
          const {
            isMobile
          } = context.conditions as gsap.Conditions;
          if (isMobile) {
            return;
          }
          const title = wrapper.querySelector(`.${css.title}`);
          if (title) {
            gsap.fromTo(title, {
              y: 80,
              opacity: 0
            }, {
              y: 0,
              opacity: 1,
              duration: 1.4,
              ease: "power3.out",
              scrollTrigger: {
                trigger: title,
                start: "top 90%",
                toggleActions: "play none none reverse"
              }
            });
            gsap.to(title, {
              yPercent: -50,
              ease: "none",
              scrollTrigger: {
                trigger: wrapper,
                start: "top bottom",
                end: "10% top",
                scrub: true
              }
            });
          }
          gsap.from(cards, {
            opacity: 0,
            ease: "power3.out",
            duration: 2,
            stagger: 0.2,
            scrollTrigger: {
              trigger: wrapper,
              start: "10% center"
            }
          });
          const yValues = [60, -50, 45];
          const rotationValues = [-9, 7, -5];
          cards.forEach((card, index) => {
            if (!yValues[index]) {
              return;
            }
            gsap.to(card, {
              yPercent: yValues[index],
              rotation: rotationValues[index],
              ease: "none",
              scrollTrigger: {
                trigger: wrapper,
                start: "top bottom",
                end: "bottom top",
                scrub: true
              }
            });
          });
        });
      }, wrapper);
      return () => {
        ctx.revert();
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = clsx("wrapper", css.wrapper);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== data.title) {
    t4 = <Typography uppercase={true} className={css.title} variant="h2" tag="h2"><StrapiRichContent content={data.title} /></Typography>;
    $[3] = data.title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== data.cards) {
    t5 = data.cards.map(_temp);
    $[5] = data.cards;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className={css.cards}>{t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Image alt="" width={1600} height={1000} quality={25} src="/assets/images/about-us-page/essence/essence-texture-bg.webp" className={css.textureBg} />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t6) {
    t8 = <section ref={wrapperRef} className={t3}>{t4}{t6}{t7}</section>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export default Essence;
function _temp(card_0, index_0) {
  return <Card key={index_0} className={css.card} text={card_0.text} imgUrl={card_0.image.url} />;
}